import {
  isString,
  isNumber,
  isBoolean,
  isNull,
  isUndefined,
} from '../helper/index.js';
import {
  LRUCache,
} from '../algo/cache/lru.js';
import {
  getFnId,
} from '../algo/hash/fn_reference_id.js';

const DefaultCacheSize = 100;

/**
 *
 * cachable pure function
 *
 * function signature: (...params Any) -> Any
 *
 * key = hash(params...)
 *
 */

const cacheFn = (fn, {
  cache,
  hashFn,
  cacheSize,
} = {}) => {
  if (!cache) {
    cache = new LRUCache(cacheSize || DefaultCacheSize);
  }

  return (...params) => {
    const key = getKey(params, hashFn);
    if (cache.has(key)) {
      return cache.get(key);
    }

    const v = fn(...params);
    cache.set(key, v);

    return v;
  };
};

/**
 *
 * 1. if param is an atomic value, like number, string, use itself as the hash part
 * 2. if param has "getHash" function, use result of getHash as the hash part of the param
 * 3. for other situation, use reference value
 *
 */
const getKey = (params, hashFn) => {
  const hashs = params.map(hashFn || getHashPart);
  return hashs.join('-');
};

// return the hash value of param
const getHashPart = (value) => {
  if (isNumber(value)) {
    return `00${value}`;
  }
  if (isBoolean(value)) {
    return `01${value}`;
  }
  if (isNull(value)) {
    return `02${value}`;
  }
  if (isString(value)) {
    return `03${value}`;
  }

  if (isUndefined(value)) {
    return `04${value}`;
  }

  if (typeof value.getHash === 'function') {
    return `1${value.getHash()}`;
  }

  if (typeof value === 'function') {
    return `2${getFnId(value)}`;
  }

  return `3${value.toString()}`;
};

export {
  cacheFn
};
